import { useIdentifyUser } from '../hooks/useIdentifyUser'

import { useAppSelector } from '@/redux/hooks'
import { selectMe } from '@/redux/me/meSlice'

/**
 * Identifies the signed-in user in mixpanel and keeps their `role` / `roles`
 * super properties in sync.
 *
 * Renders nothing. Mounted once in `_app.tsx`, inside the redux `Provider`, so
 * it re-renders when `KeyCloakProvider` dispatches `setMe`. `_app` used to read
 * `me` with a one-off `store.getState()`, which never saw the user until the
 * next client-side navigation, so events before then carried no roles.
 */
export const UserAnalytics = () => {
  const me = useAppSelector(selectMe)
  useIdentifyUser(me)

  return null
}
